import LabyrinthList from './LabyrinthList.vue';
import Labyrinth from './Labyrinth.vue';

export default {
  LabyrinthList,
  Labyrinth,
};
